import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardSidebar } from './components/DashboardSidebar';
import { SEO } from '@/components/SEO';

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-gray-950">
      <SEO title="Dashboard" noIndex />

      <DashboardSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Mobile menu button - only visible on small screens when sidebar is closed */}
      <button
        type="button"
        onClick={() => setSidebarOpen(true)}
        className="fixed left-4 top-4 z-30 rounded-lg bg-gray-800/90 p-2 text-gray-400 shadow-lg backdrop-blur-sm hover:bg-gray-700 hover:text-white lg:hidden"
        aria-label="Open menu"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </button>

      <div className="lg:pl-64">
        <main className="mx-auto max-w-6xl px-4 py-8 pt-16 lg:pt-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
